<template>
    <div class="cards-box" :loading="loading">
        <div :class="{ 'mask': isShowMask }"></div>
        <div class="level-dialog" v-if="isLevel">
            <div class="text">抱歉，您所在渠道不能参加此活动</div>
            <div class="btn" @click="goHome">
                返回首页
            </div>
        </div>
        <div class="title"></div>
        <div class="cards-rule" @click="onClickRule"></div>

        <div class="middle-box">
            <!-- 滚动播报 -->
            <div class="scroll-box">
                <van-icon name="point-gift-o" class="icon" />
                <van-notice-bar color="#111111" :scrollable="true" :text="scrollText">
                </van-notice-bar>
            </div>
            <!-- 做任务赢卡券 -->
            <div class="task-box">
                <div class="margin-task">
                    <div class="flex-between">
                        <div class="height-30 font-10">您已获得：<span style="color:#F9D96F">{{
                            activityList.couponSize
                        }}</span> 张卡券 <span style="color:#F9D96F">{{ activityList.pointValue }} </span>积分
                        </div>
                        <div class="go-coupon " @click="goToCoupon">查看您的卡包 <van-icon name="arrow" /></div>
                    </div>
                    <div class="flex-between">
                        <div class="width-200">
                            <div>每连续3天签到</div>
                            <div class="margin-5 ">
                                <van-progress :percentage="continuousSignCount" :show-pivot="false" />
                            </div>
                            <div class="flex-between">
                                <div class="font-10">越签越开心</div>
                                <div>{{ activityList.continuousSignCount }}/3
                                </div>
                                <!-- <div v-else>{{ Math.round(activityList.continuousSignCount / 3) }}/3</div> -->
                            </div>
                        </div>
                        <div class="height-center">
                            <div v-if="isActivityfinished" class="end"></div>
                            <div v-else>
                                <div class="signed" v-if="activityList.signTask === '1'"></div>
                                <div class="go-sign" v-else @click="goToSignIn"></div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-between">
                        <div class="width-200">
                            <div>浏览易加商城15s</div>
                            <div class="margin-5">
                                <van-progress v-if="activityList.mallTask === '1'" :percentage="100"
                                    :show-pivot="false" />
                                <van-progress v-else :percentage="0" :show-pivot="false" />
                            </div>
                            <div class="flex-between">
                                <div class="font-10">越看越兴隆</div>
                                <div v-if="activityList.mallTask === '1'">1/1</div>
                                <div v-else>0/1</div>
                            </div>
                        </div>
                        <div class="height-center">
                            <div v-if="isActivityfinished" class="end"></div>
                            <div v-else>
                                <div class="watched" v-if="activityList.mallTask === '1'"></div>
                                <div class="go-watch" v-else @click="goToBrowse"></div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-between">
                        <div class="width-200">
                            <div class=" display-between">
                                <div>
                                    <div>每下1笔订单</div>
                                    <!-- <div style="font-size:10px;margin-top:5px">(每日下单奖励上限为10次)</div> -->
                                </div>
                                <!-- <div class="get">当日已获{{ activityList.todayOrderPrize }}次奖励</div> -->
                                <div style="font-size:10px;margin-top:5px">每日下单奖励上限为10次</div>
                            </div>
                            <div class="margin-5">
                                <van-progress :percentage="OrderPrize" :show-pivot="false" />
                            </div>
                            <div class="flex-between">
                                <div class="font-10">越兑越富有</div>
                                <div>{{ activityList.todayOrderPrize }}/10</div>
                            </div>
                        </div>
                        <div class="height-center">
                            <div v-if="isActivityfinished" class="end"></div>
                            <div v-else class="go-order" @click="goToOrder(activityList)"></div>
                        </div>
                    </div>
                    <div class="flex-between">
                        <div class="width-200">
                            <div class=" display-between">
                                <div>每扫码10次</div>
                                <div class="get">当日已获{{ activityList.todayScanPrize }}次奖励</div>
                            </div>
                            <div class="margin-5">
                                <van-progress :percentage="scanCount" :show-pivot="false" />
                            </div>
                            <div class="flex-between">
                                <div class="font-10">越扫越幸运</div>
                                <div>{{ activityList.scanCount }}/100</div>
                            </div>
                        </div>
                        <div class="height-center">
                            <div v-if="isActivityfinished" class="end"></div>
                            <div v-else class="scaned" @click="goToScan"></div>
                        </div>
                    </div>
                    <div class="flex-between">
                        <div class="width-200">
                            <div>兑换易加2023授权牌</div>
                            <div class="margin-5">
                                <van-progress v-if="activityList.exchangeTask === '1'" :percentage="100"
                                    :show-pivot="false" />
                                <van-progress v-else :percentage="0" :show-pivot="false" />
                            </div>
                            <div class="flex-between">
                                <div class="font-10">越兑越顺利</div>
                                <div v-if="activityList.exchangeTask === '1'">1/1</div>
                                <div v-else>0/1</div>
                            </div>
                        </div>
                        <div class="height-center">
                            <div v-if="isActivityfinished" class="end"></div>
                            <div v-else>
                                <div class="ordered" v-if="activityList.exchangeTask === '1'"></div>
                                <div class="go-scan" v-else @click="goToExchange"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 排行榜 -->
            <div class="ranking-box">
                <div class="rank-box" v-if="rankingLists.length > 0">
                    <div class="top3">
                        <div class="number1" v-if="rankingLists.length > 1">
                            <div class="img-box"></div>
                            <div>{{ processName(rankingLists[1].clientName) }}</div>
                            <div style="font-size:10px ;margin-top: 5px; color: #F9D96F;">已获得奖励 {{
                                rankingLists[1].prizeCount
                            }} 次</div>
                        </div>
                        <div class="number2" v-if="rankingLists.length > 0">
                            <div class="img-box"></div>
                            <div>{{ processName(rankingLists[0].clientName) }}</div>
                            <div style="font-size:10px;margin-top: 5px; color: #F9D96F;">已获得奖励 {{
                                rankingLists[0].prizeCount
                            }} 次</div>
                        </div>
                        <div class="number3" v-if="rankingLists.length > 2">
                            <div class="img-box"></div>
                            <div>{{ processName(rankingLists[2].clientName) }}</div>
                            <div style="font-size:10px;margin-top: 5px; color: #F9D96F;">已获得奖励 {{
                                rankingLists[2].prizeCount
                            }} 次</div>
                        </div>
                    </div>
                    <div class="top3-tips">
                    </div>
                    <div class="list-title">
                        <div class="list-left">
                            <div style="margin-left:10px;">排名</div>
                            <div class="user">修理厂</div>
                        </div>
                        <div>获得奖励总次数</div>
                    </div>

                    <div v-for=" (item, index) in rankingLists" :key="index" class="list-box">
                        <div v-if="item.ranking > 3">
                            <div class="item-bg">
                                <div class="list-left">
                                    <div style="font-size:16px;margin-left:15px;">{{ item.ranking }}</div>
                                    <div style="margin-left:55px;">{{ processName(item.clientName) }}</div>
                                </div>
                                <div style="margin-right:10px;">已获得奖励 <span style="color:#ede12f">{{
                                    item.prizeCount
                                }}</span> 次</div>
                            </div>
                        </div>
                    </div>
                    <div class="watch-more" @click="watchMore">查看更多<van-icon name="arrow" /></div>
                </div>
                <div v-else class="no-ranking">
                    <div class="ranking-no">
                        暂无数据
                    </div>
                </div>
            </div>
            <!-- 扫二维码邀请得积分 -->
            <div class="qrcode-box">
                <div class="qrcode-title">本修理厂已合计邀请 <span style="color:#F9D96F">{{
                    activityList.invitationCount
                }}</span> 位员工，累计获得 <span style="color:#F9D96F">{{ activityList.invitationCount * 500 }}
                    </span>积分
                </div>
                <div class="qrcode-wrap" ref="qrCode">
                    <div id="qrcode" class="qrcode">
                        <div class="container-header"></div>
                        <div class="container-footer"></div>
                    </div>
                </div>
                <div class="qrcode-tip ">员工扫描二维码，立即绑定</div>
                <div class=" qrcode-warning "><van-icon name="warning-o" /> 通过老板的审批后才能获得积分哦！</div>
            </div>
            <!-- 兑换礼品专区 -->
            <div class="cash-box" v-if="!isActivityfinished">
                <div class="margin-cash">
                    <div class="align-center">开启时间：2023年2月15日 — 3月31日 </div>
                    <div class="align-center margin-y">定期更换，及时关注</div>
                    <div>
                        <van-list v-model="giftLoading" :finished="finished" offset="10" :immediate-check='false'
                            @load="onLoad">
                            <div class="cash-list">
                                <div v-for=" (item, index) in giftUrlList" :key="index" @click="gotoWeb(item)"
                                    class="cash-item">
                                    <img :src="getImageUrl(item.itemImageUri)" alt="" class="images">
                                    <div class="item-name">{{ item.itemName }}</div>
                                    <div class="item-count">
                                        <div style="color:red; font-weight:600;font-size: 13px;">
                                            <div> {{ item.promotionPoint }}积分</div>
                                            <div style=" color: #c2c2c2;font-size: 10px;text-decoration: line-through;">
                                                {{
                                                    item.exchangePoint
                                                }}积分</div>
                                        </div>
                                        <div class="ku-cun"><van-icon name="shop-collect-o" />{{ item.usableStock }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </van-list>
                    </div>
                </div>
            </div>
        </div>
        <!-- 活动规则弹窗 -->
        <div class="rule-dialog " v-if="isShowRule">
            <img class="rule" src="../../../assets/images/activity/cards/rule-essay.png" alt="">
            <img class="close" @click="closeRule" src="../../../assets/images/activity/cards/close.png" alt="">
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'
import { Dialog } from 'vant'
import centerApi from '@/api/center'
import activityApi from '@/api/activity'
import { commonUtils } from '@/utils/common'
export default {
  components: {

  },
  data () {
    return {
      qrcodeUrl: '',
      isShowRule: false, // 展示规则
      isShowMask: false, // 展示蒙层
      activityList: [], // 展示信息
      prizeList: [],
      rankingList: [],
      rankingLists: [],
      giftUrlList: [],
      allRankingLists: [],
      giftImgUrl: '',
      continuousSignCount: 0,
      OrderPrize: 0,
      scanCount: '',
      exchangeItemId: '',
      loading: false,
      showPopover: false,
      page: 1, // 默认展示第一页
      isActivityfinished: false, // 活动是否结束
      isLevel: false,
      giftPage: 1,
      finished: false,
      giftLoading: false
    }
  },
  created () {
    if (!localStorage.getItem('userInfo')) {
      console.log('未登录')
      this.$router.push({ name: 'login2', query: { conpon: 1 } })
    } else {
      commonUtils.reportViewTrace()
      this.getClientInfo()
      this.getActivityCoupon()
      this.getCouponRanking()
      this.getUrlCoupon()
    }
  },
  computed: {
    ...mapState({
      clientInfo: state => state.user.clientInfo
    }),
    scrollText () {
      let name = this.prizeList.map((item) => {
        return '恭喜' + item.clientName + '获得:' + item.itemName + '   。   '
      }).join('')
      return name
    }

  },
  mounted () {
  },
  methods: {
    // 获取易家活动初始化信息
    getActivityCoupon () {
      this.loading = true
      activityApi.getActivityCoupon().then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.activityList = res.data.resultData
          this.exchangeItemId = res.data.resultData.exchangeItemId
          let endDate = res.data.resultData.activityEndTime
          let nowDate = new Date().getTime()
          if (nowDate - endDate > 0) {
            console.log('当前时间大于活动结束时间')
            this.isActivityfinished = true
          } else {
            console.log('当前时间小于活动结束时间')
            this.isActivityfinished = false
          }
          this.prizeList = this.activityList.prizeList
          this.continuousSignCount = this.activityList.continuousSignCount / 3 * 100
          this.scanCount = this.activityList.scanCount
          this.OrderPrize = this.activityList.todayOrderPrize * 10
        } else {
          this.isLevel = true
          this.isShowMask = true
        }
      })
    },
    // 获取排名
    getCouponRanking () {
      let params = {
        page: 1,
        pageSize: 5
      }
      activityApi.getCouponRanking(params).then(res => {
        if (res.data.resultCode === '0') {
          this.rankingLists = res.data.resultData.taskRankingList
        }
      })
    },
    processName (str) {
      if (str) {
        if (str.length <= 7) {
          return str
        } else {
          let star = '****'
          return str.substr(0, 2) + star + str.substr(-2, 2)
        }
      }
    },
    // 查看全部排行榜
    watchMore () {
      this.$router.push({ name: 'activity-cards-ranking' })
    },
    // 获取折扣商品信息
    getUrlCoupon () {
      let params = {
        page: 1,
        pageSize: 6
      }
      activityApi.getUrlCoupon(params).then(res => {
        if (res.data.resultCode === '0') {
          let data = res.data.resultData
          this.giftUrlList = data.itemList
        }
      })
    },
    onLoad () {
      let page = this.giftPage + 1
      let params = {
        page: page,
        pageSize: 6
      }
      activityApi.getUrlCoupon(params).then(res => {
        if (res.data.resultCode === '0') {
          let itemList = res.data.resultData.itemList || []
          if (itemList !== []) {
            this.giftUrlList = this.giftUrlList.concat(itemList)
          }
          console.log(this.giftUrlList, ' this.giftUrlList')
          this.giftLoading = false
          this.giftPage++
          if (res.data.resultData.itemList < 6) {
            this.finished = true
          }
        }
      })
    },
    // 去签到
    goToSignIn () {
      this.$router.push({ name: 'signIn' })
    },
    // 去我的卡券
    goToCoupon () {
      this.$router.push({ name: 'userCoupon' })
    },
    // 去扫码
    goToScan () {
      if (this.activityList.scanCount >= 100) {
        Dialog.confirm({
          title: '提示',
          message: '今日扫码奖励已达上限，再次扫码将不会获得奖励哦！',
          confirmButtonText: '我知道啦'
        }).then(() => {
          this.$router.push({ name: '2022-scan-first-half' })
        })
      } else {
        this.$router.push({ name: '2022-scan-first-half' })
      }
    },
    goToExchange () {
      this.$router.push({ name: 'goods-detail', query: { itemId: this.exchangeItemId } })
    },
    // 去浏览
    goToBrowse () {
      this.$router.push({ name: 'home-main', query: { cards: 'cards-h5' } })
    },
    goHome () {
      this.$router.push({ name: 'home-main' })
    },
    // 去下单
    goToOrder () {
      if (this.activityList.todayOrderPrize >= 10) {
        Dialog.confirm({
          title: '提示',
          message: '今日下单奖励已达上限，再次下单将不会获得奖励哦！',
          confirmButtonText: '仍要下单'
        }).then(() => {
          this.$router.push({ name: 'home-main' })
        })
      } else {
        this.$router.push({ name: 'home-main' })
      }
    },
    // 打开规则
    onClickRule () {
      if (this.isShowMask === false) {
        this.isShowMask = true
        this.isShowRule = true
      }
    },
    // 关闭规则
    closeRule () {
      this.isShowMask = false
      this.isShowRule = false
    },
    // 获取二维码地址
    async getClientInfo () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      centerApi.clientQueryClientCount().then(res => {
        if (res.data.resultCode === '0') {
          this.clientListLength = res.data.resultData.clientCount
        }
      }).catch(() => { })
      let { data } = await centerApi.getClientInfo()
      this.$toast.clear()
      this.userInfo = data.resultData.clientInfo
      this.subClientCount = data.resultData.clientInfo.subClientCount
      this.avatarImageUri = this.userInfo.avatarImageUri
      let clientId = data.resultData.clientInfo.clientId
      //   this.qrcodeUrl = ` https://wx.bosch-extra.com.cn:8443/v2/register3?clientId=${clientId}&applyType=04`
      this.qrcodeUrl = `${document.location.origin}/v2/register3?clientId=${clientId}&applyType=04`
      this.$nextTick(() => {
        this.crateQrcode()
      })
    },
    // 生成二维码
    crateQrcode () {
      this.qr = new QRCode('qrcode', {
        width: 100,
        height: 100,
        text: this.qrcodeUrl,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    gotoWeb (item) {
      if (item.itemCategory && item.itemCategory.categoryCode !== '501') {
        this.$router.push({
          name: 'goods-detail',
          query: {
            itemId: item.itemId
          }
        })
      } else {
        this.$router.push({
          name: 'knowledge-goods',
          query: {
            itemId: item.itemId
          }
        })
      }
    },
    // 图片
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-button--round {
    border-radius: 10px;
}

/deep/ .van-button {
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    background-color: rgba(237, 242, 206, 0.764);
    color: #038a9477;
}

/deep/ .van-progress {
    border: 1px solid #F9D96F;
    background-color: rgba(255, 255, 255, 0.269);
    box-sizing: content-box;
    height: 15px !important;
    border-radius: 0.10667rem;
}

/deep/ .van-notice-bar {
    background: rgba(42, 42, 42, 0.505) !important;
    border-radius: 20px;
    height: 20px;
    line-height: 20px;

}

/deep/ .van-progress__portion {
    position: absolute;
    left: -0.5px;
    height: 100%;
    background: linear-gradient(#FDEEA8, #F9D96F);
    border-radius: inherit;
}

/deep/ .van-notice-bar__content {
    font-size: 10px;
    color: #fff;
}

.mask {
    position: fixed;
    width: 100%;
    height: 810vh;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .7);
    z-index: 3;
}

.level-dialog {
    width: 330px;
    height: 160px;
    position: absolute;
    top: 236px;
    left: 24px;
    z-index: 99;
    background-color: #ffffff;
    border-radius: 10px;
    text-align: center;

    .text {
        height: 100px;
        line-height: 100px;
        font-size: 18px;
        font-weight: 600;
    }

    .btn {
        width: 100px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto;
        border-radius: 5px;
        color: #000000;
        // rgb(170, 219, 233)
        background-color: rgb(17, 114, 129);
        border: 1px solid rgb(17, 114, 129);
        color: #ffffff;

    }
}

.cards-box {
    position: relative;
    background: url("../../../assets/images/activity/cards/bg-all.png") no-repeat;
    background-size: 100% auto;
    width: 100%;
    height: auto;

    .middle-box {
        width: 344px;
        margin: 0 auto;
    }

    .cards-rule {
        position: absolute;
        right: 0;
        top: 50px;
        width: 30px;
        height: 100px;
        z-index: 2;
        background: url("../../../assets/images/activity/cards/rule.png") no-repeat;
        background-size: 100% auto;
    }

    .title {
        text-align: center;
        font-size: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .scroll-box {
        margin-top: 160px;
        margin-bottom: 240px;
        width: 100%;
        height: 20px;
        position: relative;

        .flex-nowarp {
            display: flex;
            flex-direction: column;

        }

        .icon {
            color: #fff;
            position: absolute;
            bottom: 3.5px;
            left: 2px;
            z-index: 2;

        }

    }

    .task-box {
        color: #ffffff;
        background: url("../../../assets/images/activity/cards/task.png") no-repeat;
        background-size: 100% auto;
        height: 530px;
        margin-bottom: 20px;
        width: 100%;
        display: inline-block;
        font-size: 14px;

        //   签到
        .signed {
            background: url("../../../assets/images/activity/cards/signed.png") no-repeat;
            background-size: 100% auto;
            width: 90px;
            height: 30px;
            margin-top: 20px;
        }

        .end {
            background: url("../../../assets/images/activity/cards/end-new.png") no-repeat;
            background-size: 100% auto;
            width: 90px;
            height: 30px;
            margin-top: 20px;
        }

        .go-sign {
            background: url("../../../assets/images/activity/cards/go-sign.png") no-repeat;
            background-size: 100% auto;
            width: 90px;
            height: 30px;
            margin-top: 20px;
        }

        // 浏览
        .watched {
            background: url("../../../assets/images/activity/cards/watched.png") no-repeat;
            background-size: 100% auto;
            width: 90px;
            height: 30px;
            margin-top: 20px;
        }

        .go-watch {
            background: url("../../../assets/images/activity/cards/go-watch.png") no-repeat;
            background-size: 100% auto;
            width: 90px;
            height: 30px;
            margin-top: 20px;
        }

        // 下单
        .go-order {
            background: url("../../../assets/images/activity/cards/go-order.png") no-repeat;
            background-size: 100% auto;
            width: 90px;
            height: 30px;
            margin-top: 20px;
        }

        .scaned {
            background: url("../../../assets/images/activity/cards/scaned.png") no-repeat;
            background-size: 100% auto;
            width: 90px;
            height: 30px;
            margin-top: 20px;
        }

        // 兑换
        .ordered {
            background: url("../../../assets/images/activity/cards/ordered.png") no-repeat;
            background-size: 100% auto;
            width: 90px;
            height: 30px;
            margin-top: 20px;
        }

        .go-scan {
            background: url("../../../assets/images/activity/cards/go-scan.png") no-repeat;
            background-size: 100% auto;
            width: 90px;
            height: 30px;
            margin-top: 20px;
        }

        .margin-task {
            height: 430px;
            width: 90%;
            margin: 87px auto;
        }

        .font-10 {
            font-size: 10px;
        }

        .margin-5 {
            margin-top: 10px;
            margin-bottom: 8px;
        }

        .width-200 {
            // width: calc(100% -30px) !important;
            width: 53vw;
            display: inline-block;
        }

        .height-30 {
            line-height: 25px;
        }

        .flex-between {
            display: flex;
            justify-content: space-between;
            margin-bottom: 6px;

            .font-12 {
                font-size: 12px;
            }
        }

        .display-between {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            .get {
                font-size: 10px;
            }
        }

        .go-coupon {
            font-size: 10px;
            border: 1px solid #fff;
            padding-left: 10px;
            padding-right: 5px;
            line-height: 23px;
            border-radius: 20px;
        }
    }

    .ranking-box {
        background: url("../../../assets/images/activity/cards/ranking.png") no-repeat;
        background-size: 100% auto;
        height: 495px;
        width: 100%;
        margin-bottom: 20px;
        display: inline-block;
        position: relative;

        .no-ranking {
            text-align: center;
            height: 185px;

            .ranking-no {
                position: relative;
                top: 250px;
                color: #fff;

            }
        }

        .rank-box {
            width: 97%;
            margin: auto;

            .top3 {
                background: url("../../../assets/images/activity/cards/top3.png") no-repeat;
                background-size: 100% auto;
                width: 100%;
                height: 205px;
                margin-top: 67px;
                position: relative;
                text-align: center;
                color: #fff;

                .number1 {
                    font-size: 12px;
                    position: absolute;
                    left: 15px;
                    bottom: 50px;
                    width: 30%;
                }

                .number2 {
                    position: absolute;
                    left: 32%;
                    bottom: 60px;
                    width: 40%;
                }

                .number3 {
                    position: absolute;
                    left: 68%;
                    bottom: 50px;
                    width: 28%;
                }
            }

            .top3-tips {
                background: url("../../../assets/images/activity/cards/rank-tips.png") no-repeat;
                background-size: 100% auto;
                width: 100%;
                height: 30px;
            }

            .list-title {
                font-size: 12px;
                color: #fff;
                display: flex;
                line-height: 40px;
                justify-content: space-between;
                padding-bottom: 5px;
                width: 90%;
                margin: 0 auto;

                .list-left {
                    display: flex;

                    .user {
                        margin-left: 40px;
                    }
                }
            }

            .list-box {
                font-size: 10px;
                color: #fff;
                width: 90%;
                margin: 0 auto;

                .item-bg {
                    background: url("../../../assets/images/activity/cards/user-info.png") no-repeat;
                    background-size: 100% auto;
                    width: 100%;
                    line-height: 37px;
                    padding-bottom: 15px;
                    display: flex;
                    justify-content: space-between;
                }

                .flex-between {
                    display: flex;
                    justify-content: space-between;
                }

                .img-box {
                    margin: 1px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    background-color: rgb(151, 150, 150);
                }

                .list-left {
                    display: flex;

                    .user {
                        margin-left: 65px;
                    }
                }
            }

            .watch-more {
                position: absolute;
                bottom: 25px;
                left: 140px;
                color: #fff;
                text-align: center;
                font-size: 13px;
            }
        }

    }

    .qrcode-box {
        color: #fff;
        background: url("../../../assets/images/activity/cards/invited.png") no-repeat;
        background-size: 100% auto;
        display: inline-block;
        width: 100%;
        height: 380px;
        margin-bottom: 10px;
        font-size: 12px;

        .qrcode {
            position: relative;
            border: 5px solid #fff;

            .container-header {
                &::before {
                    content: '';
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    top: -10px;
                    left: -10px;
                    border-top: 2px solid #ede12f;
                    border-left: 2px solid #ede12f;
                }

                &::after {
                    content: '';
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    top: -10px;
                    right: -10px;
                    border-top: 2px solid #ede12f;
                    border-right: 2px solid #ede12f;
                }
            }

            .container-footer {
                &::before {
                    content: '';
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    bottom: -10px;
                    left: -10px;
                    border-bottom: 2px solid #ede12f;
                    border-left: 2px solid #ede12f;
                }

                &::after {
                    content: '';
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    bottom: -10px;
                    right: -10px;
                    border-bottom: 2px solid #ede12f;
                    border-right: 2px solid #ede12f;
                }
            }
        }

        .qrcode-title {
            text-align: center;
            margin-top: 100px;
        }

        .qrcode-tip {
            font-size: 18px;
            text-align: center;
        }

        .qrcode-warning {
            margin-top: 15px;
            font-size: 12px;
            text-align: center;
        }

        .qrcode-wrap {
            width: 100%;
            height: 150px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .cash-box {
        width: 100%;
        color: #fff;
        background: url("../../../assets/images/activity/cards/exchange.png") no-repeat;
        background-size: 100% auto;
        display: inline-block;
        font-size: 12px;
        height: 600px;
        margin-bottom: 20px;

        .margin-cash {
            width: 90%;
            margin: auto;
            margin-top: 90px;

            .cash-list {
                height: 420px;
                width: 100%;
                display: flex;
                justify-content: space-around;
                flex-wrap: wrap;
                overflow: scroll;

                .cash-item {
                    color: black;
                    width: 45%;
                    height: 190px;
                    background-color: #fff;
                    border-radius: 10px;
                    margin-bottom: 20px;

                    .item-name {
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        width: 120px;
                        height: 15px;
                        overflow: hidden;
                        font-weight: 600;
                        font-size: 12px;
                        margin-left: 10px;
                    }

                    .item-count {
                        display: flex;
                        justify-content: space-between;
                        margin: 10px;

                        .ku-cun {
                            width: 50px;
                            text-align: right;
                        }
                    }

                    .images {
                        width: 100%;
                        height: 130px;
                        border-radius: 10px;
                    }
                }
            }

            .align-center {
                text-align: center;
            }

            .margin-y {
                margin: 10px 0;
            }
        }
    }

    .rule-dialog {
        width: 327px;
        height: 400px;
        position: absolute;
        top: 5px;
        left: 24px;
        z-index: 9999;

        .rule {
            width: 327px;
        }

        .close {
            width: 44px;
            height: 44px;
            margin-left: 135px;
            margin-top: 25px;
            color: #fff;
            z-index: 9999;

        }
    }

    .ranking-list-dialog {
        position: fixed;
        width: 100%;
        height: 810vh;
        top: 0;
        left: 0;
        background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/ranking-bg.png") no-repeat;
        background-size: 100% auto;
        z-index: 3;

        .ranking-list-close {
            height: 40px;
            margin-top: 70px;

            .img {
                width: 40px;
                height: 40px;
                margin-left: 143px;
            }
        }
    }
}
</style>
